<template>
  <v-container fill-height fluid pa-0
               style="background-image: radial-gradient(farthest-corner at 50% 50%, #004678 20%, #042345 100%); user-select: none;">
    <v-row class="fill-height white--text" no-gutters>
      <v-col class="align-self-start" cols="12">
        <top-bar>
          <template v-slot:logos>
            <v-row class="fill-height flex-nowrap pt-6 pl-6" no-gutters>
              <v-col class="flex-shrink-1 pr-4" cols="auto">
                <v-img max-width="115" src="@/assets/logos/fitt_logo.svg"></v-img>
              </v-col>
              <v-col class="flex-shrink-1 " cols="auto">
                <v-img contain max-width="150" src="@/assets/logos/psychai_logo.png"></v-img>
              </v-col>
            </v-row>
          </template>
          <template v-slot:title>CEO for a Day</template>
          <template v-slot:info>
            <v-row class="pt-8 pr-8" justify="end" no-gutters>
              <v-btn dark icon x-large @click="$router.replace(`/${$route.params.app}/menu`)">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-row>
          </template>
        </top-bar>
        <v-row align="center" class="py-12 pa-4">
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/global_disease_burden_as_perc.json')"></highcharts>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/key_practitioner_statistics.json')"></highcharts>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/healthcare_share_of_gdp.json')"></highcharts>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/life_expectancy_of_selected_countries.json')"></highcharts>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/adaptation_of_nextgen.json')"></highcharts>
            <div class="text-center">
              <div><small>Global Internet Protocol Traffic 2002 to 2022</small></div>
              <div class="font-weight-bold"><small>Source: Digital Economy Report UN</small></div>
            </div>
            <v-img contain max-height="130" src="@/assets/images/ceo_info_2.svg"></v-img>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <v-simple-table v-if="!!tableData"
                            class="white--text"
                            style="background-color: transparent;"
            >
              <thead>
              <tr>
                <td colspan="2" style="border-top-left-radius: 10px; border-top-right-radius: 10px;">
                  {{ tableData.title }}
                </td>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(row, rowIndex) in tableData.data" :key="rowIndex">
                <td v-for="(col, colIndex) in row"
                    :key="colIndex"
                    :class="colIndex === 0 ? 'font-weight-bold' : ''"
                    :style="{ 'border-bottom-left-radius': rowIndex === tableData.data.length-1 && colIndex === 0 ? '10px' : '',
                              'border-bottom-right-radius': rowIndex === tableData.data.length-1 && colIndex === row.length-1 ? '10px' : '',
                              'white-space': colIndex === 0 ? 'nowrap' : ''}"
                >{{ col }}
                </td>
              </tr>
              </tbody>
            </v-simple-table>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <v-simple-table v-if="!!tableData"
                            class="white--text"
                            style="background-color: transparent;"
            >
              <thead>
              <tr>
                <td v-for="(header, index) in tableData2.headers"
                    :key="index"
                    :style="{ 'border-top-left-radius': index === 0 ? '10px' : '', 'border-top-right-radius': index === 2 ? '10px' : '' }"
                    class="text-center"
                    style="border-top-left-radius: 10px; border-top-right-radius: 10px;"
                >
                  {{ header }}
                </td>
              </tr>
              </thead>
              <tr>
                <td v-for="(col, index) in tableData2.data"
                    :key="index"
                    class="pa-3 text-center"
                >{{ col }}
                </td>
              </tr>
              <tbody>
              </tbody>
            </v-simple-table>
            <div class="text-center">
              <div><small>Global Covid-19 Statistics2</small></div>
              <div class="font-weight-bold"><small>Source: COVID Watch</small></div>
            </div>
          </v-col>
          <v-col lg="6" md="6" sm="12" xl="4" cols="12">
            <highcharts :options="require('@/assets/charts/global_gdp_perc_change.json')"></highcharts>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
    <div class="white--text"
         style="position: fixed; bottom: 0; height: 60px; width: 100%; background-color: #1D4162;">
      <stocks-ticker :stock-data="stockData"></stocks-ticker>
    </div>
  </v-container>
</template>

<script>
import TopBar from "@/components/Framework/TopBar";
import StocksTicker from "@/components/CeoForADay/StocksTicker";
import stockData from '@/assets/text/stock_data.json';
import questions from '@/assets/text/ceo_for_a_day_questions.json'
import {Chart} from 'highcharts-vue';
import Highcharts from 'highcharts';
import DataModule from 'highcharts/modules/data';

DataModule(Highcharts);

export default {
  name: "CeoForADay",
  components: {
    TopBar,
    StocksTicker,
    highcharts: Chart
  },
  data: () => ({
    tableData: null,
    infographicOne: null,
    infographicTwo: null,
    stockData: null,
    questions: []
  }),
  methods: {
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
  },
  mounted() {
    this.tableData = require('@/assets/tables/international_labour_organization.json');
    this.tableData2 = require('@/assets/tables/global_covid_19_statistic.json');
    this.infographicOne = require('@/assets/infographics/pwc_global_survey.json');
    this.infographicTwo = require('@/assets/infographics/global_internet.json');
    this.stockData = stockData;
    this.questions = questions;
  }
}
</script>

<style scoped>
tbody tr:hover {
  background-color: transparent !important;
}

table, th, td {
  border: 1px solid white;
}
</style>